import {
  makePaymentModalFooterElem,
  makePaymentModalBalanceElem,
  makePaymentModalBalanceAmountElem,
  makePaymentModalBalanceCurrentElem,
  makePaymentModalBalanceDateElem,
  makePaymentModalDisplayPayElem,
  makePaymentModalBalanceAttorneyElem
} from './constants'
import { paymentModalFooterButtons } from './footer'

export function paymentModalBalance (payment) {
  if (payment.service_unavailable) {
    paymentModalFooterButtons(false)
    makePaymentModalBalanceElem.addClass('hide')
  } else {
    let accountName = payment.unit_name

    if (payment.account_number) {
      accountName += ` (${payment.account_number})`
    }

    makePaymentModalFooterElem.attr('data-payment-url', payment.payment_url)
    makePaymentModalDisplayPayElem.attr('data-header-title', accountName)
    makePaymentModalBalanceAttorneyElem.addClass('hide');
    makePaymentModalBalanceElem.addClass('hide');

    if (payment.balance !== null) {
      if (paymentModalShowAttorneyBalance(payment)) {
        makePaymentModalBalanceElem.addClass('hide');
        makePaymentModalBalanceAttorneyElem.removeClass('hide');
      } else {
        makePaymentModalBalanceElem.removeClass('hide');
        makePaymentModalBalanceAttorneyElem.addClass('hide');
        makePaymentModalBalanceAmountElem.text(payment.formatted_balance)
        makePaymentModalBalanceAmountElem.removeClass('hide')
        makePaymentModalBalanceCurrentElem.removeClass('hide')
      }
    } else {
      makePaymentModalBalanceAmountElem.addClass('hide')
      makePaymentModalBalanceCurrentElem.addClass('hide')
    }

    if (payment.last_updated_at !== null) {
      makePaymentModalBalanceDateElem.text(`${payment.unit_name} - Last updated ${payment.last_updated_at}`)
      makePaymentModalBalanceDateElem.removeClass('hide')
    } else {
      makePaymentModalBalanceDateElem.addClass('hide')
    }

    if (paymentModalShowAttorneyBalance(payment)) {
      makePaymentModalFooterElem.addClass('hide');
    } else {
      makePaymentModalFooterElem.removeClass('hide');
    }
  }
}

export function paymentModalShowAttorneyBalance (payment) {
  return makePaymentModalBalanceAttorneyElem.length > 0 && !payment.allow_payments;
}
